module.exports = __webpack_public_path__ + "static/img/zhyw.2c092ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhyw.png
// module id = WA5L
// module chunks = 0